import React, { FC } from "react";

const ItemCardLoading: FC = () => {
  const renderSliderGallery = () => {
    return (
      <div className="relative w-full rounded-2xl overflow-hidden">
        <div className="aspect-w-16 aspect-h-9 ">
          <div
            className={`object-cover bg-gray-300 dark:bg-gray-300 bg-opacity-50 animate-pulse h-full w-full`}
          ></div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className="p-5  space-y-4">
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <div className="h-6 w-14 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"></div>
          </div>
          <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2 h-6 w-32 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"></div>
        </div>
        <div className="w-14  border-b border-neutral-100 dark:border-neutral-800"></div>
        <div className="flex justify-between items-center ">
          <div className="h-6 w-14 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"></div>
          <div className="h-6 w-14 animate-pulse bg-gray-300 bg-opacity-50 rounded-md"></div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-CarCard group relative border border-neutral-200 dark:border-neutral-700 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow bg-white dark:bg-neutral-900`}
      data-nc-id="CarCard"
    >
      <div className="flex flex-col">
        {renderSliderGallery()}
        {renderContent()}
      </div>
    </div>
  );
};

export default ItemCardLoading;
